module.exports = __webpack_public_path__ + "static/media/mdi_map-marker.91ada8a7.svg";